import { PinOutline } from '@deepup/icons';
import { projectsHistorySelectors } from '@menu/redux';
import {
  type ActivityStateFilterMode,
  filterProjectsByActivityState,
} from '@projects/pages/list/filterProjectsByActivityState';
import {
  type LabelingFilterMode,
  filterProjectsByLabeling,
} from '@projects/pages/list/filterProjectsByLabeling';
import { projectSelectors } from '@projects/redux';
import { useSelector } from 'react-redux';
import { ProjectListSection } from './ProjectListSection';
import { ProjectsTable } from './ProjectsTable';

export const ProjectListPinned = ({
  search,
  labelingFilter,
  activityStateFilter,
}: {
  search: string;
  labelingFilter: LabelingFilterMode;
  activityStateFilter: ActivityStateFilterMode;
}) => {
  const pinned = useSelector(projectsHistorySelectors.selectPinnedProjects);
  const projects = useSelector(projectSelectors.selectByIds(pinned.map((p) => p.id)));

  const labelingFiltered = filterProjectsByLabeling(projects, labelingFilter);
  const rows = filterProjectsByActivityState(labelingFiltered, activityStateFilter);

  if (rows.length === 0) return null;

  return (
    <div>
      <ProjectListSection
        primaryText="Pinned Projects"
        secondaryText={rows.length}
        Icon={PinOutline}
      />
      <ProjectsTable rows={rows} hideFooter search={search} />
    </div>
  );
};
